import $ from 'jquery'
import 'jquery-migrate/dist/jquery-migrate'
import './modules/_skip-link-focus-fix'
import './modules/_foundation-scripts'
import './modules/_desktop-menu'
import './modules/_mobile-menu'
import './modules/_popup'
import 'jquery-match-height/jquery.matchHeight.js'
import { detect } from 'detect-browser'
import Cookies from 'js-cookie'

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundled
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the config to find what is being
 * compiled out as its own file.
 *
 * When importing node modules that are not ES6 modules,
 * you do not need to path them as '../../node_modules/'.
 * Gulp knows about the node_modules directory, so all you need
 * to do is path them as if you were already in the node_modules
 * directory
 *
 * Instead of:
 * import '../../node_modules/jquery-migrate/dist/jquery-migrate';
 *
 * Use:
 * import 'jquery-migrate/dist/jquery-migrate';
 *
 */

/*************** Template part region toggle button ***************/
$('#theme_debug_regions').on('click', function (event) {
	event.preventDefault()

	$('.placeHolderPosition').slideToggle()
})

/*************** Browser Version ***************/
const browser = detect()
const browser_version = browser.version.split('.')
const browser_html_class = browser.name + '-' + browser_version[0]

$('html').addClass(browser_html_class)

$('.match-height').matchHeight()

$('.match-height-inside').matchHeight()

if ($('#gform_4').length) {
	$('input[name="input_19[]"][aria-label="Password"]').attr('type', 'password')
}

/*************** Search toggle ***************/
$('#searchFieldIcon').click(function () {
	$('#searchBox').slideToggle('slow')
})

/*************** Exit Notice ***************/
var allowedDOmains = [
	'www.firstunited.bank',
	'firstunited.cbzsecure.com',
	'firstunitedbiz.cbzsecure.com',
	'spiritmortgage.net',
	'www.spiritmortgage.net',
	'urldefense.com',
	'secure.firstunited.bank',
]

$('a')
	.not('#business-login')
	.filter(function () {
		return this.hostname && this.hostname !== location.hostname && !allowedDOmains.includes(this.hostname)
	})
	.click(function () {
		var x = window.confirm(
			'Notice:\nYou are leaving FirstUnited.Bank and entering a website that First United does not control. First United has provided this link for your convenience, but does not endorse and is not responsible for the content, links, privacy policy, or security policy of this third party website.  The products and services offered on this third party website are not provided or guaranteed by First United Bank.'
		)
		var val = false
		if (x) val = true
		else val = false
		return val
	})

/**
 * Print image.
 *
 * @param string url to image for printing.
 */
function print_image(src) {
	var win = window.open('about:blank', '_blank')
	win.document.open()
	win.document.write(
		`<html>
			<head>
			</head>
			<body onload="window.print()">
				<img style="max-width: 100%;" src="${src}"/>
			</body>
		</html>`
	)
	win.document.close()
}

$('.print-button').on('click', function (event) {
	event.preventDefault()

	const source = $(this).attr('href')

	print_image(source)
})

/*************** New Customer Checklist ***************/
$('.customer-checklist-status').on('click', function (event) {
	event.preventDefault()

	const data_value = $(this).data()

	$(this).parents('.checklist-landing__item').toggleClass('marked-as-done')

	if ($(this).text() !== 'All Done!') {
		$(this).html('All Done!')
	} else {
		$(this).html('Good Job!')
	}

	if (!Cookies.get(data_value.id)) {
		Cookies.set(data_value.id, 'clicked', { expires: 365 })
	} else {
		Cookies.remove(data_value.id)
	}
})

const custom_check_list_count = $('.customer-checklist-status').length

for (let index = 0; index <= custom_check_list_count; index++) {
	if (Cookies.get(`fub-checklist-item-${index}`) === 'clicked') {
		const checklist_item = $(`a[data-id="fub-checklist-item-${index}"]`)
		checklist_item.parents('.checklist-landing__item').toggleClass('marked-as-done')
		checklist_item.html('Good Job!')
	}
}

/*************** Podcast Conversion Tracking ***************/
// Tracking is in footer.php at the bottom of the file
$('#js_conversion_tracking')
	.find('a')
	.on('click', function () {
		window.lintrk('track', { conversion_id: 4599634 })
	})

/*************** Show/Hide Login password ***************/
$('.password-toggle').on('click', function () {
	var passwordInput = document.getElementById('password')
	if (passwordInput.type === 'password') {
		passwordInput.type = 'text'
		$(this).removeClass('password-hidden')
		$(this).addClass('password-showing')
	} else {
		passwordInput.type = 'password'
		$(this).removeClass('password-showing')
		$(this).addClass('password-hidden')
	}
})
